<template>
  <div :class="classes" class="slider">
    <div class="inline-block">
      <img src="/images/spinner.gif" alt="Loading..." />
    </div>
    <p v-if="$slots.default" class="text-center text-lg text-gray-500">
      <slot />
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoadingSpinner",

  props: {
    color: {
      type: String,
      default: "#E8E8E8",
    },
    classes: {
      type: String,
      default: "p-6 text-center",
    },
    width: {
      type: String,
      default: "w-12",
    },
    height: {
      type: String,
      default: "h-12",
    },
  },
});
</script>

<style>
.bg-light-green .slider .text-center {
  @apply text-white;
}
</style>
